import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { StaffAddRequest, StaffAddResponse, StaffListResponse, StaffUpdateRequest, StaffUpdateResponse } from './Staff.constants'
import axiosInstance from '../../shared/service/axios'

export const useStaffAddMutation = (): UseMutationResult<StaffAddResponse, AxiosError, StaffAddRequest> =>
  useMutation<StaffAddResponse, AxiosError, StaffAddRequest>(async (requestValues: StaffAddRequest) => {
    const { data, status } = await axiosInstance.post('account/', requestValues)
    data.status = status

    return data
  })

export const useStaffUpdateMutation = (): UseMutationResult<StaffUpdateResponse, AxiosError, StaffUpdateRequest> =>
  useMutation<StaffUpdateResponse, AxiosError, StaffUpdateRequest>(async (requestValues: StaffUpdateRequest) => {
    const { data, status } = await axiosInstance.put('account/' + requestValues.id + '/', requestValues)
    data.status = status

    return data
  })

export const useStaffDeleteMutation = (): UseMutationResult<any, AxiosError, string> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete('account/' + requestValues + '/')

    return status
  })

export const useStaffListMutation = (): UseMutationResult<StaffListResponse, AxiosError, any> =>
  useMutation<StaffListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get('account/')

    return data
  })
